import { Injector } from "@angular/core";
import { WorkspaceBase } from "../../workspace-base/workspace-base";
import { GridActionHandlerBase } from "./grid-action-handler-base";
import { AppLoadingIndicatorService } from "../../../../services/app-loading-indicator.service";

/**
 * Hides the legacy loader
 */
export class HideLegacyLoaderGridActionHandler extends GridActionHandlerBase {
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   */
  constructor(injector: Injector, workspace: WorkspaceBase, topic: string, private appLoadingIndicator: AppLoadingIndicatorService) {
    super(injector, workspace, topic);
  }

  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    this.appLoadingIndicator.hide();
  }
}
